import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, AlertTriangle } from "lucide-react";

const VendorVerification = () => {
  const { data: pendingVendors } = useQuery({
    queryKey: ["vendors-verification"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vendors")
        .select("*")
        .eq("verification_status", "pending");

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="space-y-6">
      <div className="grid gap-6">
        {pendingVendors?.map((vendor) => (
          <Card key={vendor.id} className="p-6">
            <div className="flex items-start justify-between">
              <div className="space-y-1">
                <h3 className="text-lg font-medium">{vendor.name}</h3>
                <p className="text-sm text-muted-foreground">
                  {vendor.business_type}
                </p>
                <Badge variant="outline">
                  {vendor.verification_status}
                </Badge>
              </div>
              <div className="flex gap-2">
                <Button variant="outline" className="gap-2">
                  <AlertTriangle className="h-4 w-4" />
                  Reject
                </Button>
                <Button className="gap-2">
                  <ShieldCheck className="h-4 w-4" />
                  Verify
                </Button>
              </div>
            </div>
            {vendor.ai_analysis && (
              <div className="mt-4 p-4 bg-muted rounded-md">
                <h4 className="font-medium mb-2">AI Analysis</h4>
                <pre className="text-sm">
                  {JSON.stringify(vendor.ai_analysis, null, 2)}
                </pre>
              </div>
            )}
          </Card>
        ))}
        {!pendingVendors?.length && (
          <Card className="p-6">
            <p className="text-center text-muted-foreground">
              No pending verifications
            </p>
          </Card>
        )}
      </div>
    </div>
  );
};

export default VendorVerification;